import av from '../lib/av';
import {initPromoBanner} from '../lib/promoBanner';
av(function() {
    initPromoBanner(this);
});